/* Elyvenza – propose de passer de l'oreiller seul au Pack Sommeil Complet dans le panier */
(function () {
  var PILLOW_PRODUCT = 16388492820815;
  // variante "Oreiller de grossesse" -> variante "Pack Sommeil Complet" de la même couleur
  var TO_PACK = {
    59123360334159: 59123379011919, // Crème
    59123379044687: 59123379077455, // Turquoise
    59123379110223: 59123379142991  // Pêche
  };
  var BOX_CLASS = 'ely-pack-upsell';
  // textes selon la langue de la boutique (fr par défaut)
  var DE = ((window.Shopify && Shopify.locale) || document.documentElement.lang || '').indexOf('de') === 0;
  var TXT = DE
    ? { title: 'Wechsel zum Komplett-Schlafset', sub: 'Füge das lange Ganzkörperkissen für nur', btn: 'Zum Set wechseln' }
    : { title: 'Passez au Pack Sommeil Complet', sub: 'Ajoutez le coussin long corps entier pour seulement', btn: 'Passer au Pack' };
  var busy = false, timer = null;

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',').replace(',00', '') + ' €';
  }

  function containers() {
    var list = [];
    var drawerFooter = document.querySelector('cart-drawer .drawer__footer');
    if (drawerFooter) list.push(drawerFooter);
    var pageFooter = document.querySelector('.cart__footer, #main-cart-footer');
    if (pageFooter && window.location.pathname.indexOf('/cart') !== -1) list.push(pageFooter);
    return list;
  }

  function render(item, packPrice) {
    var diff = (packPrice - item.price) * item.quantity;
    containers().forEach(function (c) {
      var box = c.querySelector('.' + BOX_CLASS);
      if (!box) {
        box = document.createElement('div');
        box.className = BOX_CLASS;
        c.insertBefore(box, c.firstChild);
      }
      box.innerHTML =
        '<div class="ely-pack-upsell__text"><strong>' + TXT.title + '</strong>' +
        '<span>' + TXT.sub + ' <b>+' + money(diff) + '</b>' + (DE ? ' hinzu' : '') + '</span></div>' +
        '<button type="button" class="ely-pack-upsell__btn">' + TXT.btn + '</button>';
      box.querySelector('button').onclick = function () { swap(item, this); };
    });
  }

  function clear() {
    document.querySelectorAll('.' + BOX_CLASS).forEach(function (b) { b.remove(); });
  }

  function check() {
    if (busy) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = cart.items.find(function (i) { return i.product_id === PILLOW_PRODUCT && TO_PACK[i.variant_id]; });
        if (!item) { clear(); return; }
        return fetch('/products/' + item.handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
          var pack = p.variants.find(function (v) { return v.id === TO_PACK[item.variant_id]; });
          if (pack && pack.available) render(item, pack.price); else clear();
        });
      })
      .catch(function () {});
  }

  function swap(item, btn) {
    if (busy) return;
    busy = true;
    btn.disabled = true; btn.textContent = '…';
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: TO_PACK[item.variant_id], quantity: item.quantity }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 })
    })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        busy = false;
        if (window.location.pathname.indexOf('/cart') !== -1 || !drawer || !res.sections) { window.location.reload(); return; }
        drawer.renderContents(res);
        schedule();
      })
      .catch(function () { busy = false; window.location.reload(); });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(check, 250); }

  document.addEventListener('DOMContentLoaded', function () {
    check();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(function (m) {
      // ignore nos propres insertions
      if (m.every(function (x) { return [].every.call(x.addedNodes, function (n) { return n.classList && n.classList.contains(BOX_CLASS); }); })) return;
      schedule();
    }).observe(drawer, { childList: true, subtree: true });
  });
})();
